import { render } from "./ViewCard.vue?vue&type=template&id=61feff90&scoped=true"
import script from "./ViewCard.vue?vue&type=script&lang=js"
export * from "./ViewCard.vue?vue&type=script&lang=js"

import "./ViewCard.vue?vue&type=style&index=0&id=61feff90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61feff90"]])

export default __exports__